const root = document.querySelector('ksh-halloween-game');
if (root && !root.dataset.ready) {
  root.dataset.ready = 'true';
  const params = new URLSearchParams(location.search);
  const previewDate = params.get('ksh_preview_date');
  const previewTime = window.Shopify?.theme?.role === 'unpublished' && previewDate ? Date.parse(previewDate) : NaN;
  const clockStart = Date.now();
  const now = () => Number.isFinite(previewTime) ? previewTime + Date.now() - clockStart : Date.now();
  const startTime = Date.parse(root.dataset.start);
  const endTime = Date.parse(root.dataset.end);
  const active = () => now() >= startTime && now() < endTime;
  const home = new URL(root.dataset.home, location.origin);
  if (Number.isFinite(previewTime)) home.searchParams.set('ksh_preview_date', previewDate);
  const dialog = root.querySelector('dialog');
  const pots = [...root.querySelectorAll('.khg-pot')];
  const start = root.querySelector('.khg-start');
  const sound = root.querySelector('.khg-sound input');
  const status = root.querySelector('.khg-status');
  const scare = root.querySelector('.khg-scare');
  const finish = root.querySelector('.khg-finish');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const timers = new Set();
  let state = 'intro';
  let audio;
  let boundaryTimer;
  let runId = 0;
  let slots = [0, 1, 2];
  const later = (fn, ms) => { const id = setTimeout(() => { timers.delete(id); fn(); }, ms); timers.add(id); return id; };
  const pause = ms => new Promise(resolve => later(resolve, ms));
  function stop() {
    runId += 1;
    for (const id of timers) clearTimeout(id);
    timers.clear();
    audio?.pause();
    if (audio) audio.currentTime = 0;
  }
  function goHome() {
    if (state === 'leaving') return;
    state = 'leaving';
    stop();
    try { sessionStorage.setItem('ksh-welcomed-v2', '1'); } catch {}
    location.replace(home.href);
  }
  function clone(selector) { return root.querySelector(selector).content.firstElementChild.cloneNode(true); }
  function mountLinks() {
    if (document.querySelector('.khg-promo')) return;
    if (document.querySelector('.ks-home')) {
      const card = clone('.khg-promo-template');
      const games = document.querySelector('.ks-game')?.closest('section');
      if (games) games.before(card);
      else document.querySelector('.ks-home').append(card);
    } else if (location.pathname.replace(/\/$/, '').endsWith('/pages/arcade')) {
      document.querySelector('main')?.prepend(clone('.khg-promo-template'));
    }
  }
  function checkSeason() {
    clearTimeout(boundaryTimer);
    if (active()) {
      mountLinks();
      boundaryTimer = setTimeout(checkSeason, Math.min(Math.max(1, endTime - now()), 3600000));
    } else {
      document.querySelectorAll('.khg-season-link').forEach(link => link.remove());
      if (params.get('spel') === 'halloween') goHome();
      if (now() < startTime) boundaryTimer = setTimeout(checkSeason, Math.min(startTime - now(), 3600000));
    }
  }
  const setSlots = () => pots.forEach((pot, i) => {
    pot.style.setProperty('--slot', slots[i]);
    pot.querySelector('.khg-pot-number').textContent = String(slots[i] + 1);
    pot.setAttribute('aria-label', `${root.dataset.potLabel || 'Ketel'} ${slots[i] + 1}`);
  });
  start.addEventListener('click', async () => {
    if (state !== 'intro' || !active()) return;
    state = 'shuffling';
    start.disabled = true;
    status.textContent = root.dataset.follow;
    audio = new Audio(root.dataset.audio);
    audio.preload = 'auto';
    audio.volume = .7;
    audio.load();
    const currentRun = ++runId;
    const valid = () => currentRun === runId && state === 'shuffling' && active();
    pots[1].classList.add('is-revealed');
    await pause(1300);
    if (!valid()) return;
    pots[1].classList.remove('is-revealed');
    await pause(500);
    if (!valid()) return;
    for (let round = 0; round < 5; round += 1) {
      const a = Math.floor(Math.random() * 3);
      const b = (a + 1 + Math.floor(Math.random() * 2)) % 3;
      pots[a].classList.add('is-crossing');
      [slots[a], slots[b]] = [slots[b], slots[a]];
      setSlots();
      await pause(reduced.matches ? 700 : 570);
      if (!valid()) return;
      pots[a].classList.remove('is-crossing');
      await pause(100);
      if (!valid()) return;
    }
    state = 'choosing';
    status.textContent = root.dataset.choose;
    start.hidden = true;
    pots.forEach(pot => { pot.disabled = false; });
    pots[slots.indexOf(0)].focus({ preventScroll: true });
  });
  pots.forEach(pot => pot.addEventListener('click', () => {
    if (state !== 'choosing') return;
    if (!active()) { goHome(); return; }
    state = 'scaring';
    pots.forEach(item => { item.disabled = true; });
    pot.classList.add('is-revealed');
    if (sound.checked && audio) {
      audio.currentTime = 0;
      audio.play().catch(() => {});
    }
    later(() => { scare.hidden = false; status.textContent = root.dataset.boo; }, 400);
    later(() => {
      scare.hidden = true;
      finish.hidden = false;
      status.textContent = root.dataset.return;
      finish.querySelector('a').focus({ preventScroll: true });
    }, 1270);
    later(goHome, 4900);
  }));
  sound.addEventListener('change', () => { if (audio) audio.muted = !sound.checked; });
  dialog.addEventListener('cancel', event => { event.preventDefault(); goHome(); });
  dialog.querySelectorAll('a').forEach(link => link.addEventListener('click', event => { event.preventDefault(); goHome(); }));
  document.addEventListener('visibilitychange', checkSeason);
  document.addEventListener('shopify:section:load', checkSeason);
  window.addEventListener('pageshow', event => {
    if (event.persisted && params.get('spel') === 'halloween') goHome();
    else checkSeason();
  });
  window.addEventListener('pagehide', () => { stop(); clearTimeout(boundaryTimer); });
  checkSeason();
  if (params.get('spel') === 'halloween' && active()) {
    document.querySelector('.ksh-welcome')?.setAttribute('hidden', '');
    document.documentElement.classList.add('khg-playing');
    dialog.showModal();
    start.focus({ preventScroll: true });
  }
}
